// extracted by mini-css-extract-plugin
module.exports = {"page":"guides-hub_page__FLtsP","seoSection":"guides-hub_seoSection__RuQsi","fullWidthCta":"guides-hub_fullWidthCta__KsN2F"};